(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/endpoints/favorites-api.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/endpoints/favorites-api.js');
"use strict";


const {
  jupiterFetch
} = svs.core;
const {
  fetchBaseQuery,
  createApi
} = RTKQ;
const {
  CasinoPreferenceNames,
  getPreferences,
  putPreference,
  isCloudPreferencesEnabled
} = svs.components.casino.preferences;
const useCloudPreferences = isCloudPreferencesEnabled();
const createCloudGetFavoritesEndpoint = builder => builder.query({
  async queryFn() {
    try {
      const casinoPreferences = await getPreferences();
      return {
        data: casinoPreferences.favorites
      };
    } catch (error) {
      return {
        error: {
          status: error.status,
          data: error.message,
          message: error.message
        }
      };
    }
  },
  providesTags: ['Favorites']
});
const createLegacyGetFavoritesEndpoint = builder => builder.query({
  query: () => '/casino/1/favorites',
  transformResponse: response => response.favorites || [],
  providesTags: ['Favorites']
});
const createCloudUpdateFavoritesEndpoint = builder => builder.mutation({
  async queryFn(favorites) {
    try {
      await putPreference({
        name: CasinoPreferenceNames.FAVORITES,
        values: favorites
      });
      return {
        data: undefined
      };
    } catch (error) {
      return {
        error: {
          status: error.status,
          data: error.message,
          message: error.message
        }
      };
    }
  },
  invalidatesTags: ['Favorites']
});
const createLegacyUpdateFavoritesEndpoint = builder => builder.mutation({
  query: favorites => ({
    url: "/casino/1/favorites?favorites=".concat(encodeURIComponent(favorites.join(';'))),
    method: 'PUT'
  }),
  invalidatesTags: ['Favorites']
});
const favoritesApi = createApi({
  reducerPath: 'favoritesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: jupiterFetch.url(),
    fetchFn: jupiterFetch.fetch,
    prepareHeaders: headers => {
      headers.set('Content-Type', 'application/json');
      return headers;
    }
  }),
  tagTypes: ['Favorites'],
  endpoints: builder => ({
    getFavorites: useCloudPreferences ? createCloudGetFavoritesEndpoint(builder) : createLegacyGetFavoritesEndpoint(builder),
    updateFavorites: useCloudPreferences ? createCloudUpdateFavoritesEndpoint(builder) : createLegacyUpdateFavoritesEndpoint(builder)
  })
});
setGlobal('svs.components.casino_react.casinoStore.endpoints.favoritesApi', favoritesApi);

 })(window);